import { NEXT_SHELL_NAV_ITEMS } from './navigation-config';

const INSPECT_NAV = NEXT_SHELL_NAV_ITEMS.find((item) => item.id === 'inspect');

/** Classic product routes grouped under Next-shell Inspect (excludes `/inspect/quality`). */
export const INSPECT_CLASSIC_CHILD_PATHS: readonly string[] =
  INSPECT_NAV?.children
    ?.map((child) => child.path)
    .filter((path) => !path.startsWith('/inspect/')) ?? [];

export const INSPECT_QUALITY_PATH = '/inspect/quality';

export function isInspectClassicChildPath(pathname: string): boolean {
  return INSPECT_CLASSIC_CHILD_PATHS.some(
    (base) => pathname === base || pathname.startsWith(`${base}/`)
  );
}
